import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PartDetailService } from '../part-detail.service';

@Component({
  selector: 'zoomin-dialog',
  templateUrl: './zoomin-dialog.component.html',
  styleUrls: ['./zoomin-dialog.component.scss']
})
export class ZoominDialogComponent implements OnInit {
  @Input() show:boolean;
  @Input() data:any;  

  constructor(private readonly partDetailService: PartDetailService) { }

  ngOnInit() {
  }

  getTitle() {
    return this.data.title.value;
  }

  getImageSource() {
    return this.data.imagePath.value;
  }

  closeForm() {
    this.partDetailService.showZoomInDialog = false;
    this.partDetailService.zoomInData = null;
  }
 
}
